/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ b: NonNullable<unknown> }} Battery_LowInputs */



/**
* | output |
* | --- |
* | "Low battery ({b})" |
*
* @param {Battery_LowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const battery_low = /** @type {((inputs: Battery_LowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Battery_LowInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Low battery (${i?.b})`)
	return /** @type {LocalizedString} */ (`Batterie faible (${i?.b})`)
});